module.exports = __webpack_public_path__ + "img/horror.4337b8a4.svg";